// removed by extract-text-webpack-plugin
module.exports = {"togglePlayButton":"dh-trygdis-kvinnefengsel-togglePlayButton","togglePlayButton__playIcon":"dh-trygdis-kvinnefengsel-togglePlayButton__playIcon","togglePlayButton--paused":"dh-trygdis-kvinnefengsel-togglePlayButton--paused","togglePlayButton__pauseIcon":"dh-trygdis-kvinnefengsel-togglePlayButton__pauseIcon"};


//////////////////
// WEBPACK FOOTER
// ./src/lib/@nrk/dh-feature-components/Video/TogglePlayButton.css
// module id = 205
// module chunks = 0